import React from 'react';
import { WSRManager } from '../features/wsr';

const WSRPage: React.FC = () => {
  // For now, using Costco as default client (ID: 1)
  // This could be dynamic based on route params or user selection
  const clientId = 1; // Costco client ID
  
  return (
    <WSRManager 
      clientId={clientId} 
      clientName="Costco HighJump WMS"
    />
  );
};

export default WSRPage;